import { render, staticRenderFns } from "./ProductStockKanbanTV.vue?vue&type=template&id=680cc6de&"
import script from "./ProductStockKanbanTV.vue?vue&type=script&lang=js&"
export * from "./ProductStockKanbanTV.vue?vue&type=script&lang=js&"
import style0 from "./ProductStockKanbanTV.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports